import React  from 'react';

import styles from './styles.module.css';

function AccordionBody({children}){
    
    const renderBasicAccordion = () => (
        <ul className={styles.accordionBody}>
            {children}
        </ul>
    );

    return renderBasicAccordion();
} 

export default AccordionBody;